import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import type { PermissionsItem } from '@/modules/api/codegen';
import { useIsAdmin } from '@/modules/auth/hooks';
import { hasWritePermission } from '@/utilities/permission';

import { SharingPermission } from '../constants';
import { selectGeneralSettings } from '../services/selectors';

export const useHasSharingPermissions = () => {
    const isAdmin = useIsAdmin();
    const { sharingPermission: globalSharingPermission } = useSelector(selectGeneralSettings);

    const getHasSharingPermissions = useCallback(
        (userPermissions: PermissionsItem[]) => {
            const canWrite = hasWritePermission(userPermissions);

            if (globalSharingPermission === SharingPermission.ADMIN_ONLY) {
                return isAdmin;
            }

            if (globalSharingPermission === SharingPermission.EVERYONE) {
                return canWrite;
            }

            return false;
        },
        [isAdmin, globalSharingPermission],
    );

    return { getHasSharingPermissions };
};
